<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark-brand">
    <router-link
      :to="{ name: 'home.index' }"
      class="navbar-brand">
      <span class="site-logo"><img src="/logo-inverse.png" ></span>
    </router-link>

    <button
      class="navbar-toggler"
      type="button"
      @click="toggleMenu">
      <span class="navbar-toggler-icon" />
    </button>

    <div
      :class="{ show : menuCollapsed}"
      class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <router-link
          :to="{ name: 'home.index' }"
          exact
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Home
          </a>
        </router-link>

        <router-link
          :to="{ name: 'digitalMedia.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Digital Media
          </a>
        </router-link>

        <router-link
          :to="{ name: 'physicalMedia.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Physical Media
          </a>
        </router-link>

        <router-link
          :to="{ name: 'socialMedia.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Social Media
          </a>
        </router-link>

        <router-link
          :to="{ name: 'aboutUs.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            About Us
          </a>
        </router-link>

        <router-link
          :to="{ name: 'contactUs.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Contact Us
          </a>
        </router-link>

        <!-- <router-link
          :to="{ name: 'portfolio.index' }"
          active-class="active"
          class="nav-item"
          tag="li">
          <a class="nav-link">
            Portfolio
          </a>
        </router-link> -->
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      menuCollapsed: false,
    };
  },
  methods: {
    /**
       * Will toggle the menu.
       */
    toggleMenu() {
      this.menuCollapsed = !this.menuCollapsed;
    },
  },
};
</script>
